<script setup>
import { Head, Link, useForm, usePage } from '@inertiajs/vue3';

const form = useForm({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    address: "",
    resume: "",
    image: ""
})

const submit = () => {
    try {
        form.post(route('career.job.application.submit'), {
            onSuccess: page => {
                form.reset();
                successToast(page.props.flash.message);
            }
        });
    } catch (error) {
        errorToast('Something went wrong!');
    }
}

const fnameErrorClear   = () => {return form.clearErrors('first_name')}
const lnameErrorClear   = () => {return form.clearErrors('last_name')}
const phoneErrorClear   = () => {return form.clearErrors('phone')}
const emailErrorClear   = () => {return form.clearErrors('email')}
const addressErrorClear = () => {return form.clearErrors('address')}
const resumeErrorClear  = () => {return form.clearErrors('resume')}
const imageErrorClear   = () => {return form.clearErrors('image')}

// form.setError('first_name', 'Your error message.');

</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container xl:pt-20 pt-12 lg:pb-4 mx-auto">
            <div class="flex flex-wrap lg:pt-4">
                <div class="xl:w-1/2 lg:w-3/4 w-full lg:px-8 px-4 mx-auto wow animate__animated animate__fadeInLeft">
                    <h2 class="text-gray-900 xl:text-[45px] lg:text-[40px] text-[30px] font-medium title-font">{{$t("career.title")}}</h2>
                    <p class="lg:text-lg text-sm text-gray-500 xl:mb-8 lg:mb-4 mb-2">{{$t("career.sub_title")}} <span
                            class="text-primary">helpcenter@nochinta.xyz</span> </p>

                    <form @submit.prevent="submit">
                        <div class="mb-4">
                            <label for="name" class="text-sm font-medium text-black">{{$t("career.first_name")}}</label>
                            <input v-model="form.first_name" @change="fnameErrorClear()" type="text" id="name" name="name"
                                class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 xl:py-2 lg:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                placeholder="Your first name">
                                <p class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2">{{ form.errors.first_name }}</p>
                        </div>
                        <div class="mb-4">
                            <label for="name" class="text-sm font-medium text-black">{{$t("career.last_name")}}</label>
                            <input v-model="form.last_name" @change="lnameErrorClear()" type="text" id="name" name="name"
                                class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 xl:py-2 lg:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                placeholder="Your last name">
                                <p class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2">{{ form.errors.last_name }}</p>
                        </div>
                        <div class="relative mb-4">
                            <label for="phone" class="text-sm font-medium text-black">{{$t("career.phone_number")}}</label>
                            <input v-model="form.phone" @change="phoneErrorClear()" type="text" id="phone" name="phone"
                                class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 xl:py-2 lg:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                placeholder="+8801700000000">
                                <p class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2">{{ form.errors.phone }}</p>
                        </div>
                        <div class="mb-4">
                            <label for="email" class="text-sm font-medium text-black">{{$t("career.email")}}</label>
                            <input v-model="form.email" @change="emailErrorClear()" type="email" id="email" name="email"
                                class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 xl:py-2 lg:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                placeholder="You@company.com">
                                <p class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2">{{ form.errors.email }}</p>
                        </div>
                        <div class="mb-4">
                            <label for="address" class="text-sm font-medium text-black">{{$t("career.address")}}</label>
                            <input v-model="form.address" @change="addressErrorClear()" type="text" id="address" name="help"
                                class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-700 xl:py-2 lg:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                placeholder="Your address">
                                <p class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2">{{ form.errors.address }}</p>
                        </div>
                        <div class="mb-4">
                            <label for="resume" class="text-sm font-medium text-black">{{$t("career.upload_resume")}}</label>
                            <input @input="form.resume = $event.target.files[0]" @change="resumeErrorClear()" type="file" id="resume" name="resume"
                                class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none file:bg-gray-400 text-gray-700 xl:py-1 py-0 mt-1 leading-6 transition-colors duration-200 ease-in-out">
                                <p class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2">{{ form.errors.resume }}</p>
                        </div>

                        <div class="mb-6">
                            <label for="image" class="text-sm font-medium text-black">{{$t("career.upload_photo")}}</label>
                            <input @input="form.image = $event.target.files[0]" @change="imageErrorClear()" type="file" id="image" name="image"
                                class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none file:bg-gray-400 text-gray-700 xl:py-1 py-0 mt-1 leading-6 transition-colors duration-200 ease-in-out">
                                <p class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2">{{ form.errors.image }}</p>
                        </div>
                        <button type="submit"
                            class="flex w-full text-center justify-center items-center text-white bg-primary border-0 py-2 px-8 focus:outline-none hover:bg-[#1565C0] transition duration-300 rounded xl:text-lg lg:text-base text-sm uppercase"
                            :class="{ 'opacity-25': form.processing }" :disabled="form.processing">{{$t("career.submit")}}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
